// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const EmailLogs = t.struct({
    emailUrlValue: t.String,
    modifiedBy: t.String,
    timeStamp: t.String,
    remark: t.String,
    communicationType: t.String
}, {
    defaultProps: {
        emailUrlValue: '',
        modifiedBy: '',
        timeStamp: '',
        remark: '',
        communicationType: ''
    },
    name: 'EmailLogs',
    strict: true
});
